import { createContext, useContext, useMemo } from 'react';
import type { DirectDealsConfig, DirectDealsProviderProps } from './types';

const directDealsContext = createContext<DirectDealsConfig>({
  useDirectDealsListFetch: () => {
    throw new Error('useDirectDealsListFetch: Not implemented. Ensure you are inside the DirectDealsContext');
  },
  useDirectDealsList: () => {
    throw new Error('useDirectDealsList: Not implemented. Ensure you are inside the DirectDealsContext');
  },
  useDirectDealsDetailsFetch: () => {
    throw new Error('useDirectDealsDetailsFetch: Not implemented. Ensure you are inside the DirectDealsContext');
  },
  useDirectDealsContact: () => {
    throw new Error('useDirectDealsContact: Not implemented. Ensure you are inside the DirectDealsContext');
  },
});

export const useDirectDealsContext = () => useContext(directDealsContext);

export const DirectDealsProvider = ({ children, directDealsConfig }: DirectDealsProviderProps) => {
  const value: DirectDealsConfig = useMemo(
    () => ({
      ...directDealsConfig,
    }),
    [directDealsConfig]
  );

  return <directDealsContext.Provider value={value}>{children}</directDealsContext.Provider>;
};
